import { ActionTypes } from "../../constants/ActionTypes";
import { ILetterBody } from "../../interfaces";

const INIT_STATE: ILetterBody = {
  letterBodys: [],
};

export default (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case ActionTypes.FETCH_LetterBody_SUCCESS: {
      return {
        ...state,
        letterBodys: action.payload,
      };
    }

    case ActionTypes.GET_LetterBody: {
      return {
        ...state,
        letterCode: action.letterCode,
        letterBodys: [],
      };
    }

    default:
      return state;
  }
};
